import React, { Component } from 'react';
import Select from 'react-select';
import 'react-select/dist/react-select.css';
import { I18n } from 'react-i18next';

class SelectInput extends Component {
  state = {
    selectedOption: this.props.value || '',
  };

  onOpen = () => {
    if (this.props.onListOpen) {
      this.props.onListOpen(this.props.value);
    }
  };

  onClose = () => {
    if (this.props.onClose) {
      this.props.onClose();
    }
  };

  onChange = (selectedOption) => {
    this.setState({ selectedOption });
    if (this.props.handleChange) {
      this.props.handleChange(selectedOption, this.props.title);
    }
  };

  render() {
    const selectedOption =
      this.props.options.length <= 1 ? this.props.options[0] : this.state.selectedOption;
    const options = this.props.selectOptions || this.props.options;

    return (
      <I18n ns="translations">
        {(t) => (
          <div className="input">
            {this.props.title ? (
              <p className="input-name">
                {t('api_filters', { returnObjects: true })[this.props.title] || this.props.title}
              </p>
            ) : (
              ''
            )}
            <Select
              disabled={this.props.disabled}
              onClose={this.onClose}
              onOpen={this.onOpen}
              placeholder={t('generic_labels.please_select')}
              clearable={false}
              name={'form-field-' + this.props.title}
              onChange={this.onChange}
              value={selectedOption}
              options={options}
              searchable={false}
            />
          </div>
        )}
      </I18n>
    );
  }
}

export default SelectInput;



// WEBPACK FOOTER //
// ./src/components/selectInput.js